




import VueOptions from '@utils/VueOptions'
import OrganizerRecapShow from '../../components/OrganizerRecap/OrganizerRecapShow'

settings =
  name: 'OrganizerRecapShowPage'

  vue:
    components: {
      OrganizerRecapShow,
    }

export default VueOptions.vue settings
